import { useQuery } from "@tanstack/react-query";
import useFetch from "../lib/useFetch";
import { IDeliveryMethod } from "../types/seederOrders";

const API = process.env.REACT_APP_API;

const useDeliveryMethods = () => {
  const fetch = useFetch();

  return useQuery(["delivery-methods"], () => {
    return fetch(`${API}/api/semeadora/delivery-methods/`, {
      method: "GET",
    }) as Promise<IDeliveryMethod[]>;
  });
};

export default useDeliveryMethods;
